import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { Box } from '@applyboard/ui-components';
import BackButton from "../BackButton";
import CloseButton from "../../Common/CloseButton/ConnectedCloseButton";
import SaveAndExitModal from "../../Common/SaveAndExitModal";
import { useAppContext } from "../../Providers";
import { QuestionSetHeading } from "../../../Wizards/QuestionSetHeading";
var Layout = function Layout(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    exiting = _useState2[0],
    setExiting = _useState2[1];
  var _useAppContext = useAppContext(),
    showSaveAndExitModal = _useAppContext.showSaveAndExitModal;
  var onClose = function onClose() {
    // Don't show modal if from the search page
    setExiting(!showSaveAndExitModal);
  };
  var onSaveAndExitClose = function onSaveAndExitClose() {
    setExiting(false);
  };
  var children = props.children,
    _props$noBackButton = props.noBackButton,
    noBackButton = _props$noBackButton === void 0 ? false : _props$noBackButton,
    onExit = props.onExit,
    onSave = props.onSave;
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    p: 5,
    overflow: "hidden",
    width: "100%"
  }, /*#__PURE__*/React.createElement(SaveAndExitModal, {
    isMobile: true,
    open: exiting,
    onClose: onSaveAndExitClose,
    onExit: onExit,
    onSave: onSave
  }), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gridRowGap: "24px"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: noBackButton ? 'right' : 'space-between'
  }, !noBackButton && /*#__PURE__*/React.createElement(BackButton, null), /*#__PURE__*/React.createElement(CloseButton, {
    onClick: onClose,
    onExit: onExit
  })), /*#__PURE__*/React.createElement(QuestionSetHeading, {
    text: "Background"
  })), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column"
  }, children));
};
export default Layout;